import React from 'react';
import CollectionEntryToModel from './CollectionEntryToModel.js';
import ForEach from './ForEach.js';

function ForEachModel(props) {
  return /*#__PURE__*/React.createElement(ForEach, null, /*#__PURE__*/React.createElement(CollectionEntryToModel, null, props.children));
}

export default ForEachModel;
//# sourceMappingURL=ForEachModel.js.map
